import styled from 'styled-components'
import { DigitizeConfirmationModel } from './model'

const DigitizeConfirmation = styled(DigitizeConfirmationModel)`
  #root &{
    >p{
      margin: 0;
    }
    >.username{
      color: #63c0e8;
      font-size: 1.5rem;
      text-align: center;
    }
  }
`

export { DigitizeConfirmation }